import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import SwatchCartState from "@tSurya/Store/Data/SwatchCartState";
import { Draft } from "immer";

const initialState: SwatchCartState = {
    isThumbnailRowExpanded: false,
};

const reducer = {
    "Pages/SwatchMiniCart/ToggleThumbnailRowExpanded": (draft: Draft<SwatchCartState>) => {
        draft.isThumbnailRowExpanded = !draft.isThumbnailRowExpanded;
    },
    "Pages/SwatchMiniCart/SetThumbnailRowExpanded": (draft: Draft<SwatchCartState>, action: { value: boolean }) => {
        draft.isThumbnailRowExpanded = action.value;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
